import { render, staticRenderFns } from "./ListOfSpots.vue?vue&type=template&id=9703c5f8&"
import script from "./ListOfSpots.vue?vue&type=script&lang=ts&"
export * from "./ListOfSpots.vue?vue&type=script&lang=ts&"
import style0 from "./ListOfSpots.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports